export const getSegmentCheckedBaggageSummaries = (checkedBaggageSummary, segment) => {
  const { boundSummaries } = checkedBaggageSummary || {};
  if (boundSummaries?.length && segment) {
    const { segmentSummaries } =
      boundSummaries.find(({ boundId }) => boundId === segment.boundId) || {};
    if (segmentSummaries?.length) {
      return segmentSummaries.find(
        ({ segmentId }) => segment.segmentId === `${segment.boundId}${segmentId}`,
      ).summaries;
    }
    return [];
  }
  return [];
};
